import { useState } from "react";
import { CONTENT } from "@/content";
import { API, copyText, getAnonId, useApi } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import { PrayerModal, ThankYouModal } from "@/components/share/ShareModals";

const S = CONTENT.share;
const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";
const genRef = () => Array.from(crypto.getRandomValues(new Uint8Array(10)), (b) => CHARS[b % CHARS.length]).join("");
const fill = (tpl, v) => tpl.replace(/\{(title|reference|link)\}/g, (_, k) => v[k]).replace(/\s+/g, " ").trim();
const isPhone = () => window.matchMedia("(pointer: coarse)").matches && !!navigator.share;
const enc = encodeURIComponent;

export const ShareRow = ({ item }) => {
  const api = useApi();
  const { settings } = useSettings();
  const [stage, setStage] = useState(null);
  const [pending, setPending] = useState(null);
  const [note, setNote] = useState("");
  const base = `${API}/s/${item.slug}`;

  const flash = (text) => { setNote(text); setTimeout(() => setNote(""), 3000); };

  const tap = (platform) => setPending(platform);

  // Runs from the Amen click, so browsers still treat the share as user-initiated.
  const proceed = () => {
    const platform = pending;
    setPending(null);
    if (platform === "copy") { copyText(base); flash(S.copied); setStage("thanks"); return; }
    const ref = genRef();
    const link = `${base}?r=${ref}`;
    const vals = { title: item.title, reference: item.verse_reference };
    const msg = fill(settings.site.share_message, { ...vals, link });
    const msgNoLink = fill(settings.site.share_message, { ...vals, link: "" });
    api("post", "/shares", { ref, content_id: item.id, platform, anon_id: getAnonId() }).catch(() => {});
    const urls = {
      whatsapp: `https://wa.me/?text=${enc(msg)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}`,
      x: `https://twitter.com/intent/tweet?text=${enc(msgNoLink)}&url=${enc(link)}`,
      threads: `https://www.threads.net/intent/post?text=${enc(msg)}`,
    };
    if (urls[platform]) window.open(urls[platform], "_blank", "noopener,noreferrer");
    else if (isPhone()) navigator.share({ title: item.title, text: msgNoLink, url: link }).catch(() => {});
    else { copyText(link); flash(S.pasteIn[platform]); }
    setStage("thanks");
  };

  const copy = () => tap("copy");

  return (
    <section className="share-row" data-testid="share-row">
      <h2 className="admin-h2">{S.heading}</h2>
      <div className="share-buttons">
        {S.platforms.map(([key, label]) => (
          <button key={key} className="share-btn" onClick={() => tap(key)} data-testid={`share-${key}-button`}>{label}</button>
        ))}
        <button className="share-btn" onClick={copy} data-testid="share-copy-link-button">{S.copyLink}</button>
      </div>
      <p className="share-note" aria-live="polite" data-testid="share-note">{note}</p>
      {pending && <PrayerModal onAmen={proceed} onCancel={() => setPending(null)} />}
      {stage === "thanks" && <ThankYouModal onClose={() => setStage(null)} />}
    </section>
  );
};
